module.exports = __webpack_public_path__ + "static/media/ZEUS.0fa92e9f.jpg";